import { EGlobalFetchingServices } from '~/composables/useGlobal';

export default {
  [EGlobalFetchingServices.ticket + '9002']:
    'One of the workflows contains open tickets and you cannot change its open/closed status',
  [EGlobalFetchingServices.ipbx + '1000']:
    'Department identifier already exists',
  [EGlobalFetchingServices.ipbx + '1001']: 'Invalid department identifier',
  [EGlobalFetchingServices.ipbx + '3000']: 'Item already made',
  [EGlobalFetchingServices.ipbx + '3005']:
    'A user with this number is already registered. Please enter another number.',

  [EGlobalFetchingServices.ipbx + '3006']:
    'A user with this number is not registered in Navatel. Please register the user in Navatel first and then try again.',

  [EGlobalFetchingServices.sms + '1000']:
    'There is no recipient or all recipients are blocked',
  [EGlobalFetchingServices.sms + '1001']: 'Not enough balance',
  [EGlobalFetchingServices.sms + '1002']: 'The number is not valid',
  [EGlobalFetchingServices.sms + '1003']: 'File format is not valid',
  [EGlobalFetchingServices.sms + '1004']: 'No group or contact exists',
  [EGlobalFetchingServices.sms + '1005']:
    'The number of customer number requests exceeds the specified value',
  [EGlobalFetchingServices.sms + '1006']:
    'A request has already been sent for this number',
  [EGlobalFetchingServices.sms + '1007']: 'Template does not exist',
  [EGlobalFetchingServices.sms + '1008']: 'Authentication information is not valid.',
  [EGlobalFetchingServices.sms + '1009']: 'Username or password is incorrect.',
  [EGlobalFetchingServices.sms + '1010']: 'Could not connect to the service provider. Please try again.',
  [EGlobalFetchingServices.sms + '1011']: 'No response was received from the service provider.',
  [EGlobalFetchingServices.sms + '1012']: 'Too many requests. Please try again in a few minutes.',
  [EGlobalFetchingServices.sms + '1013']: 'The SMS service is temporarily unavailable.',

  [EGlobalFetchingServices.sms + '1409']: 'Duplicate contact',

  [EGlobalFetchingServices.invoice + '8001']: 'Product not available',
  [EGlobalFetchingServices.invoice + '8002']: 'Product selection is required',
  [EGlobalFetchingServices.invoice + '8003']:
    'The quantity of each selected product must be greater than zero',

  'Request Timeout': 'The request was unsuccessful, please try again.',
  'Bad Request': 'Invalid request structure',
  Unauthorized: 'Unauthorized access',
  Forbidden: 'Unauthorized access',
  'Api Not Found': 'API not found',
};
